import { SERVER } from './config';
import Swal from 'sweetalert2';
import Cookie from 'js-cookie';
import '../scss/global.scss';
import '../scss/header.scss';
import '../scss/contact.scss';

window.addEventListener('load', () => {
  const $ = window.$;

  const locale = Cookie.get('locale');

  $('.btn-reset').on('click', () => {
    $('.form input, .form textarea').val('');
  });

  $('.btn-submit').on('click', () => {
    const okText = locale === 'en-us' ? 'Cool' : '好的';
    if (!$('#number').val()) {
      const msg = locale === 'en-us' ?
        'Please enter your contact number' : '请输入你的联系电话';
      Swal.fire({
        title: msg,
        icon: 'info',
        confirmButtonText: okText,
      });
      return;
    }
    if (!$('#email').val()) {
      const msg = locale === 'en-us' ?
        'Please enter your email' : '请输入你的电子邮箱';
      Swal.fire({
        title: msg,
        icon: 'info',
        confirmButtonText: okText,
      });
      return;
    }
    const data = {
      name: $('#name').val(),
      company: $('#company').val(),
      number: $('#number').val(),
      email: $('#email').val(),
      requirement: $('#requirement').val(),
    };
    $.post(`${SERVER}/message/add`, data, (res) => {
      const msg = locale === 'en-us' ?
        'Success' : '提交成功';
      Swal.fire({
        title: msg,
        icon: 'success',
        confirmButtonText: okText,
      });
      $('.form input, .form textarea').val('');
    });
  });

  const AMap = window.AMap;
  $('.banner').addClass('animated');
  const location = [121.023001, 30.081759];
  const map = new AMap.Map('map', {
    zoom: 16,
    center: location,
    lang: locale === 'en-us' ? 'en' : 'zh_cn',
    // lang: 'zh_cn',
  });
  const marker = new AMap.Marker({
    icon: 'https://webapi.amap.com/theme/v1.3/markers/n/mark_b.png',
    position: location,
  });
  map.add(marker);
});
